import React, { useEffect, useState } from 'react';
import Navbar from '../../../components/Backoffice/Navbar/Navbar';
import Section from '../../../components/Backoffice/Display/Section';
import AnalyticsControls from './AnalyticsControls';
import moment from 'moment';
import { Divider } from 'primereact/divider';
import { privateFetch } from '../../../utils/apiHelper';
import { buildGraphPayload } from '../../../utils/analyticsHelper';
import PropertyPieChart from './PropertyPieChart';
import PropertyDatatable from './PropertyDatatable';
import RoomsDatatable from './RoomsDatatable';

function AnalyticsPage() {
  const [controls, setControls] = useState({
    dates: {
      start_dt: new Date(moment().subtract(1, 'year').format()),
      end_dt: new Date()
    },
    residencyTypeList: [],
    timeRangeMode: 'LAST_12_MONTHS',
    graphicType: 'propertyRepartition' // propertyRepartition, roomDetails
  });

  const [displayMode, setDisplayMode] = useState('chart'); // chart or datatable
  const [propertyChartRepartitionData, setPropertyChartRepartitionData] = useState(undefined);
  const [propertyDatatableRepartitionData, setPropertyDatatableRepartitionData] =
    useState(undefined);
  const [roomDetailsData, setRoomDetailsData] = useState(undefined);

  useEffect(() => {
    if (controls.graphicType === 'propertyRepartition') {
      fetchPropertyRepartitionData();
    } else {
      fetchRoomsDetailsData();
    }
  }, [controls?.dates, controls?.graphicType, controls?.residencyTypeList, displayMode]);

  const fetchPropertyRepartitionData = async () => {
    await privateFetch(
      'GET',
      `/analytics/properties/${displayMode}/${buildGraphPayload(controls)}`
    ).then((res) => {
      if (displayMode === 'chart') setPropertyChartRepartitionData(res);
      else setPropertyDatatableRepartitionData(res);
    });
  };

  const fetchRoomsDetailsData = async () => {
    await privateFetch('GET', `/analytics/rooms/datatable/${buildGraphPayload(controls)}`).then(
      (res) => {
        setRoomDetailsData(res);
      }
    );
  };

  const propertiesActions = [
    {
      label: displayMode === 'chart' ? 'Affichage tableau' : 'Affichage graphique',
      icon: displayMode === 'chart' ? 'pi pi-table' : 'pi pi-chart-pie',
      onClick: () => setDisplayMode(displayMode === 'chart' ? 'datatable' : 'chart')
    }
  ];

  return (
    <div className={`h-screen w-screen bg-white flex flex-col`}>
      <Navbar />
      <div className="page-wrapper">
        <div className="flex flex-row gap-x-5">
          <AnalyticsControls controls={controls} setControls={setControls} />
          <Divider layout="vertical" />
          {controls.graphicType === 'propertyRepartition' ? (
            <Section
              label="Répartition des tags"
              actions={propertiesActions}
              showDivider={false}
              className={'w-full'}>
              {displayMode === 'chart' ? (
                <PropertyPieChart data={propertyChartRepartitionData} />
              ) : (
                <PropertyDatatable data={propertyDatatableRepartitionData} />
              )}
            </Section>
          ) : (
            <Section label="Détails des salles" className="w-full" showDivider={false}>
              <RoomsDatatable data={roomDetailsData} />
            </Section>
          )}
        </div>
      </div>
    </div>
  );
}

export default AnalyticsPage;
